import { pageDefinition } from 'site-modules/shared/pages/page';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { getModelState } from 'client/data/luckdragon/model';
import { CmsModel } from 'client/data/models/cms';
import { parseContent } from 'client/data/cms/content';
import { getMeta, getSeoImage } from 'site-modules/shared/utils/seo-helper';
import { MPC_CONTENT_PATH } from 'client/site-modules/infographics/constants/most-popular-colors';

import { MostPopularColors } from './most-popular-colors';

export const pageDefinitionConfiguration = {
  name: 'most_popular_colors',
  category: 'best_selling_cars',
  seo: state => {
    const modelState = getModelState(state);
    const content = modelState.get(`content["${MPC_CONTENT_PATH}"]`, CmsModel);
    const parsedContent = parseContent(content);
    const meta = getMeta(parsedContent);
    return {
      ...meta,
      image: getSeoImage(parsedContent),
    };
  },
  preload: store => {
    const preloader = new ModelPreloader(store);
    preloader.resolve(`content["${MPC_CONTENT_PATH}"]`, CmsModel);
    return preloader.load();
  },
  component: MostPopularColors,
};

export default pageDefinition(pageDefinitionConfiguration);
